import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=187ef0dc&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ef0dc",
  null
  
)

export default component.exports